<div class="popover-wrapper">
    <div class="popover-header">{{title}}</div>
    <div class="layout-container">
        <nb-card-header>
            <nb-actions size="small">
                <nb-action  title="Visible"
                    class="popover-icon" (click)="onVisibilityChange(VisibilityEnum.VISIBLE)">
                    <nb-icon icon="visibility" pack="section-menu-icons"/>
                    <!-- <svg viewBox="0 0 24 24" id="ic_title_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                        <path d="M5 4v3h5.5v12h3V7H19V4z" />
                    </svg> -->
                </nb-action>
                <nb-action title="Hidden"
                    class="popover-icon" (click)="onVisibilityChange(VisibilityEnum.HIDDEN)">
                    <nb-icon icon="hidden" pack="section-menu-icons"/>
                    <!-- <svg viewBox="0 0 24 24" id="ic_format_shapes_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                        <path d="M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"/>
                    </svg> -->
                </nb-action>
                <nb-action title="Hidden On Mobile"
                    class="popover-icon" (click)="onVisibilityChange(VisibilityEnum.HIDDEN_ON_MOBILE)">
                    <nb-icon icon="mobile-off" pack="section-menu-icons"/>
                    <!-- <svg viewBox="0 0 24 24" id="ic_format_color_text_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                        <path fill-opacity=".36" d="M0 20h24v4H0z" />
                        <path d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z" />
                    </svg> -->
                </nb-action>
            </nb-actions>
        </nb-card-header>
    </div>
</div>
